module.exports = __webpack_public_path__ + "static/33F324_6_0-ccf9a39fade1ce0ae67eaf723ffec128.ttf";